import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { FrameDetectionService } from '../services/frame-detection.service'; // Service to detect if the app is running inside an iframe
import { AuthService } from '../../../auth/auth.service'; // Service to handle authentication logic

@Injectable({
  providedIn: 'root'
})
export class IframeGuard implements CanActivate {

  // Injecting dependencies using the new injection pattern
  private frameDetectionService = inject(FrameDetectionService); // Frame detection service
  private router = inject(Router); // Router service for navigation
  private authService = inject(AuthService); // Authentication service to check if the user is logged in

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    // Check if the app is running inside an iframe
    if (this.frameDetectionService.isIframe()) {

      // If the user is authenticated, navigate to the /research page
      if (this.authService.isAuthenticated()) {
        this.router.navigate(['/research']);
      } else {
        // If not authenticated, navigate to a 404 or restricted page since user doesn't have access to /research, would otherwise result in infinite loop
        this.router.navigate(['/404']);
      }
      return false; // Prevent access to the route
    }

    // Allow access to the route if running inside an iframe
    return true;
  }
}
